// src/features/user/userSaga.js
import { call, put, takeLatest } from "redux-saga/effects";
import {
  checkIsLoggedIn,
  getUserAndPaymentInfo,
  logout,
} from "../../services/userService"; // Ensure this path is correct
import {
  getUserInfoRequest,
  getUserInfoSuccess,
  getUserInfoFailure,
  getProjectInfoSuccess,
  getProjectInfoFailure,
  getProjectInfoRequest,
  checkUserLoggedInRequest,
  checkUserLoggedInSuccess,
  checkUserLoggedInFailure,
  logoutRequest,
  logoutSuccess,
  logoutFailure,
  getLatestProjectId,
} from "./userSlice";
import { getProjectDetailsByUserId } from "../../services/projectService";
// import { setAlert } from '../alert/alertSlice';

function* handleCheckUserLoggedIn(action) {
  try {
    const { navigate, dispatch } = action?.payload;
    const response = yield call(() => checkIsLoggedIn());
    yield put(checkUserLoggedInSuccess(response));
    dispatch(getUserInfoRequest(response.userId));
    dispatch(getProjectInfoRequest());
    navigate("/");
    // yield put(setAlert({ type: 'success', message: 'Login successful!' }));
  } catch (error) {
    yield put(checkUserLoggedInFailure(error.message));
    // yield put(setAlert({ type: 'error', message: 'Login failed!' }));
  }
}

function* getUserInfo(action) {
  try {
    const id = action.payload;
    const response = yield call(() => getUserAndPaymentInfo(id));
    yield put(getUserInfoSuccess(response));
  } catch (error) {
    yield put(getUserInfoFailure(error.message));
  }
}

function* getProjectInfo(action) {
  try {
    const response = yield call(() => getProjectDetailsByUserId());
    yield put(getProjectInfoSuccess(response));
    yield put(
      getLatestProjectId(
        response?.project
          ?.filter((p) => p.is_benchmark_saved)
          ?.sort((a, b) => new Date(b.createdAt) - a.createdAt)[0]?.id
      )
    );
  } catch (error) {
    yield put(getProjectInfoFailure(error.message));
    // yield put(setAlert({ type: 'error', message: 'Failed to fetch user info!' }));
  }
}

function* handleLogout(action) {
  try {
    const response = yield call(() => logout());
    yield put(logoutSuccess(response));
    window.location.href = "/";
    // yield put(setAlert({ type: 'success', message: 'Login successful!' }));
  } catch (error) {
    yield put(logoutFailure(error.message));
    // yield put(setAlert({ type: 'error', message: 'Login failed!' }));
  }
}

export function* watchUserSaga() {
  yield takeLatest(checkUserLoggedInRequest.type, handleCheckUserLoggedIn);
  yield takeLatest(getUserInfoRequest.type, getUserInfo);
  yield takeLatest(getProjectInfoRequest.type, getProjectInfo);
  yield takeLatest(logoutRequest.type, handleLogout);
}
